<template>
    <div class="all">
        <div class="clearfix">
            <div class="w400 ml20 fr">
                <div class="grid h-auto">
                    <div class="grid-header">
                        <h2 class="title">分析词</h2>
                    </div>
                    <div class="grid-body mt30">
                        <div class="ci-warp clearfix">
                            <span class="ci" v-for="(item,index) in detail.keywords" :key="index">{{item}}</span>
                        </div>
                    </div>
                </div>
                <div class="grid h-auto mt20">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">情感判断</h2>
                    </div>
                    <div class="grid-body">
                        <div class="echart-warp">
                            <!-- <halfPieChart id="halfPieChart" :dataArray="halfPieChartData" v-if="halfPieChartData != ''"></halfPieChart> -->
                            <div class="emotion mt30 clearfix" v-if="emotion === '正面'">
                                <h2 class="color-blue fl">正面</h2>
                                <span class="fr"><i class="icons front-icon"></i></span>
                            </div>
                            <div class="emotion mt30 clearfix" v-if="emotion === '负面'">
                                <h2 class="color-red fl">负面</h2>
                                <span class="fr"><i class="icons negative-icon"></i></span>
                            </div>
                            <div class="emotion mt30 clearfix" v-if="emotion === '中性'">
                                <h2 class="color-orange fl">中性</h2>
                                <span class="fr"><i class="icons neutral-icon"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid h-auto mt20" v-if="defaultWords != ''">
                    <div class="grid-header">
                        <h2 class="title">主题词</h2>
                    </div>
                    <div class="grid-body mt30">
                        <div class="echart-warp hidden h259">
                            <cloudChart id="wordCloud" :dataArray="defaultWords" cuozu="50px"></cloudChart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden">
                <div class="detail-warp clearfix">
                    <div class="clearfix">
                        <div class="fr mt5 ml20">
                            <span class="collect mt5 fl cp" :title="detail.collectStatus === 0 ? '收藏' : '取消收藏'" @click="collectFn(id);" :class="detail.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon"></i></span>
                            <span class="sign sign-orange cp fl ml20" :title="detail.warningStatus === 0 ? '预警' : '取消预警'" :class="detail.warningStatus === 0 ? '' : 'gray'" @click="isEarlyWarning(detail.warningStatus,detail.originNewsTitle);">警</span>
                            <span class="sign sign-blue cp fl ml20" @click="oneClickCopy()">复</span>
                        </div>
                        <h1 v-html="detail.newsTitle" class="hidden detail-title"></h1>
                    </div>
                    <p class="ziduan color-8a8a99 mt10">
                        <span>时间：{{detail.newsPosttime}}</span>
                        <span>发布人：<i class="icons sm-icon" :class="$parent.icons[detail.platform]"></i>{{detail.mediaName}}</span>
                        <a class="color-blue ml20" :href="detail.newsUrl" target="view_window">原文链接</a>
                    </p>
                    <div class="content mt30" v-html="detail.newsContent" v-if="detail.platform != 'video'"></div>
                    <div class="content mt30" v-if="detail.platform === 'video'">
                        <video class="video" :src="detail.newsVideoUrls[0]" controls="controls" v-if="detail.newsVideoUrls.length > 0">
                            请升级您的浏览器
                        </video>
                        <img :src="detail.newsImgUrls[0]" class="db" v-if="detail.newsVideoUrls.length < 0" referrerPolicy="no-referrer"/>
                    </div>
                    <!-- 评论详情时显示以下 -->
					<div class="mt20" v-if="detail.type === 1">
						<p class="color-blue">原文内容&nbsp;&dArr;</p>
						<div class="comment-detail" v-html="detail.newsOriginContent"></div>
					</div>
                </div>
            </div>
        </div>
        <!-- 一键复制 -->
		<copy ref="copy" :text="copyHtml"></copy>
	</div>
</template>
<script>
// import halfPieChart from '../../components/echart/halfPieChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
import copy from '../../components/copy.vue';
export default {
    components:{cloudChart,copy},
    data() {
        return {
            // halfPieChartData:[],//分析词
            copyHtml:'',
            emotion:'',//情感属性
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            defaultWords:[],
            newsVideoUrls:'',//视频链接
            id:'',
            planId:'',
            detail:[]
        }
    },
    mounted() {
		this.$nextTick(()=> {
            this.getDetailInformation();
        })
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取信息
        getDetailInformation () {
            let that = this;
            let data = that.$route.query.data.split(',');//获取当前页面url的type
            let match = data[4];
            if(!data[4]){
                match = 1;
            }
            that.id = data[0];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/info/detail',{newsId:data[0],simHash:data[1],startDate:data[2],endDate:data[3],match:match},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.detail = r.data;
                    that.halfPieChartAjax();
                    that.wordEcharts();
					that.$nextTick(() =>{
						that.MarkHighLight(document.querySelector('.content'),r.data.keywordsReg,r.data.ambiguousReg);
						that.MarkHighLight(document.querySelector('.detail-title'),r.data.keywordsReg,r.data.ambiguousReg);
					})
                });           
            })
        },
        // 一键复制
		oneClickCopy (){
			let that = this;
            let detail = that.detail;
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            for(let i in copyFields){
                this.copyHtml += copyFields[i]+':'+detail[i]+'\n'
            }
			// this.copyHtml = '标题: '+detail.originNewsTitle+'\n链接: '+detail.newsUrl+'\n时间: '+detail.newsPosttime+'\n来源:'+detail.platformName+'\n作者: '+detail.mediaName+'\n情感属性: '+detail.newsEmotion+'\n分析词: '+detail.keywords+'';
		},
		halfPieChartAjax(){
            let that = this;
            // let newData =  {
            //     total:1,
            //     data:{value:that.detail.newsEmotionScore, name:that.detail.newsEmotion}
            // };
            that.emotion = that.detail.newsEmotion;
        },
        // 主题词
        wordEcharts () {
            let that = this;
            this.defaultWords = that.detail.newsKeywords;
        },
        // 收藏
        collectFn (id) {
            let that = this;
            let newsList = that.newsList;
            let sc = that.detail.collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let data = {
                type:1,
                typeId:[id]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    sc = sc === 0 ? 1 : 0;
                    that.detail.collectStatus = sc;
                    that.$utils.alertText('操作成功');
                });
                
            })
        },  
        // 是否预警
        isEarlyWarning (type,title){
            let that = this;
            if(type === 0){//预警
                that.$confirm(title,'发送预警').then(() => {
                    that.earlyWarning(type)
                }) 
            }else{//取消
                that.earlyWarning(type)
            }
        },
        // 预警
        earlyWarning () {
            let that = this;
            this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
            let isSupportArtificialWarningSet = that.$parent.isSupportArtificialWarningSet;//检测预警功能
            if(isSupportArtificialWarningSet != 1){
                that.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
                return;
            }
            let uuid = [that.id];
            let url = '';
            let type = that.detail.warningStatus;
            if(type === 0){//添加预警
                url = 'monitor/warning/artificial-create';
            }else if(type === 1){//取消预警
                url = 'monitor/warning/artificial-delete';
            }
            let datas = {
                sid:that.planId,
                newsId:uuid
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    if(type === 0){//添加预警
                        that.detail.warningStatus = 1;
                    }else if(type === 1){//取消预警
                        that.detail.warningStatus = 0;
                    }
                    that.$utils.alertText(r.msg);
                });
            })
        },
		// 俞俊杰高亮法
		MarkHighLight(obj,hlWords,agWords){
			hlWords=this.AnalyzeHighLightWords(hlWords);
			agWords=this.AnalyzeHighLightWords(agWords);
			if(obj==null || hlWords.length==0) return;
			this.MarkHighLightCore(obj,hlWords,agWords);
		},
		MarkHighLightCore(obj,keyWords,agWords){
		    var re=new RegExp(keyWords, "i");
			let html = '';
		    for(var i=0; i<obj.childNodes.length; i++){
		        var childObj=obj.childNodes[i];
		        if(childObj.nodeType==3){
		            if(childObj.data.search(re)==-1)continue;
		            if(agWords.length > 0){
		                var agResult = new RegExp("("+agWords+")", "gi");
		                childObj.data = childObj.data.replace(agResult,"<span class='not-red'>$1</span>")
		            }
		            var reResult = new RegExp("("+keyWords+")", "gi");
					console.log(childObj.data,reResult)
		            var objResult=document.createElement("span");
		            objResult.innerHTML=childObj.data.replace(reResult,"<em class='highlight'>$1</em>");
		            obj.replaceChild(objResult,childObj);     
		        }else if(childObj.nodeType==1){
		            this.MarkHighLightCore(childObj,keyWords,agWords);
		        }
		    }
			
		},    
				
		//----------分析关键词----------------------
		AnalyzeHighLightWords(hlWords){
		    if(hlWords==null) return "";
		    hlWords=hlWords.replace(/\|+/g,"|");            
		    hlWords=hlWords.replace(/(^\|*)|(\|*$)/g, "");
		    
		    if(hlWords.length==0) return "";
		    var wordsArr=hlWords.split("|"); 
		    
		    if(wordsArr.length>1){
		        var resultArr=this.BubbleSort(wordsArr);
		        var result="";
		        for(var i=0;i<resultArr.length;i++){
		            result=result+"|"+resultArr[i];
		        }                
		        return result.replace(/(^\|*)|(\|*$)/g, "");
				
		    }else{
		        return hlWords;
		    } 
		},    
		
		//-----利用冒泡排序法把长的关键词放前面-----    
		BubbleSort(arr){        
		    var temp, exchange;    
		    for(var i=0;i<arr.length;i++){            
		        exchange=false;                
		        for(var j=arr.length-2;j>=i;j--){                
		            if((arr[j+1].length)>(arr[j]).length){                    
		                temp=arr[j+1]; arr[j+1]=arr[j]; arr[j]=temp;
		                exchange=true;
		            }
		        }                
		        if(!exchange)break;
		    }
		    return arr;            
		}
		// 俞俊杰高亮法结束
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/detail.vue